import React from 'react';
import { splitLinks } from '../utils/links';
import './LinkifiedText.css';

// Message text with its http(s):// and www. addresses clickable.
//
// Text stays React text nodes (escaped — never HTML, never dangerouslySetInnerHTML);
// links are <a> elements whose href went through webHref (http/https only), open in
// a new tab without access to this window (noopener noreferrer), and show their
// full target on hover. Line breaks: one <span> per line followed by <br />, as
// the ticket view always rendered message text.
const normalize = (text) => {
    if (typeof text === 'string') return text;
    if (typeof text === 'number') return String(text);
    return '';
};

const LinkifiedText = ({ text }) => (
    <>
        {normalize(text).split('\n').map((line, index) => (
            <span key={index}>
                {splitLinks(line).map((part, partIndex) => (part.type === 'link' ? (
                    <a
                        key={partIndex}
                        className="linkified-text__link"
                        href={part.href}
                        target="_blank"
                        rel="noopener noreferrer"
                        title={part.href}
                    >
                        {part.value}
                    </a>
                ) : (
                    <React.Fragment key={partIndex}>{part.value}</React.Fragment>
                )))}
                <br />
            </span>
        ))}
    </>
);

export default LinkifiedText;
